var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoisture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 15.6649C13.578 15.6649 15.6673 13.5673 15.6673 10.9799C15.6673 8.39245 13.578 6.29492 11.0007 6.29492C8.42332 6.29492 6.33398 8.39245 6.33398 10.9799C6.33398 13.5673 8.42332 15.6649 11.0007 15.6649Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59066 6.51411C8.79232 5.25879 7.55566 3.4718 5.66732 0.606445C1.19566 7.39254 0.33399 8.11494 0.33399 10.311C0.332599 11.2605 0.583098 12.1932 1.05973 13.0133C1.53637 13.8333 2.22195 14.5112 3.04599 14.9771C3.87004 15.4431 4.80282 15.6803 5.74844 15.6644C6.69407 15.6486 7.61843 15.3802 8.42649 14.8868",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 8.6377L8.66602 13.3227",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49935 10.3109C9.95959 10.3109 10.3327 9.93634 10.3327 9.4743C10.3327 9.01225 9.95959 8.6377 9.49935 8.6377C9.03911 8.6377 8.66602 9.01225 8.66602 9.4743C8.66602 9.93634 9.03911 10.3109 9.49935 10.3109Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 13.3226C12.9596 13.3226 13.3327 12.9481 13.3327 12.486C13.3327 12.024 12.9596 11.6494 12.4993 11.6494C12.0391 11.6494 11.666 12.024 11.666 12.486C11.666 12.9481 12.0391 13.3226 12.4993 13.3226Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoisture);
export default __webpack_public_path__ + "static/media/moisture.6b89ea2b.svg";
export { ForwardRef as ReactComponent };